import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';

import DataTable from './../../../components/DataTable/DataTable';

const styles = theme => ({
  paperWidth: {
    width: '720px',
  },
  days: {
    marginBottom: theme.spacing(5),
  },
  strong: {
    fontWeight: theme.typography.fontWeightStrong,
  },
  vertical: {
    border: 'none',
    borderLeft: `1px solid ${theme.palette.divider}`,
    height: '100%',
    width: '1px',
  },
});

const ScheduleDialog = ({
  classes, open, onClose, schedule,
}) => {
  const columns = [
    {
      name: 'days',
      label: 'Dias',
    },
    {
      name: 'firstShiftIni',
      label: 'Início Turno 1',
    },
    {
      name: 'firstShiftEnd',
      label: 'Término Turno 1',
    },
    {
      name: 'secondShiftIni',
      label: 'Início Turno 2',
    },
    {
      name: 'secondShiftEnd',
      label: 'Término Turno 2',
    },
  ];

  let content = null;
  console.log('prev',schedule)
  const rotation = schedule == false? false : schedule.workingDay.isRotation  
  if (rotation) {
    columns.shift();
    content = (
      <React.Fragment>
        <Grid container justify="space-between" className={classes.days}>
          <Grid item xs={3}>
            <Typography color="textSecondary" align="center">
              Categoria de tempo
            </Typography>
            <Typography
              color="textSecondary"
              variant="body1"
              align="center"
              className={classes.strong}
            >
              {schedule.workingDay.category === 'DAYS' ? 'DIAS' : 'HORAS'}
            </Typography>
          </Grid>
          <Grid item xs>
            <hr className={classes.vertical} />
          </Grid>
          <Grid item xs={3}>
            <Typography color="textSecondary" align="center">
            {schedule.workingDay.category === 'DAYS' ? 'Dias' : 'Horas'} de trabalho
            </Typography>
            <Typography
              color="textSecondary"
              variant="body1"
              align="center"
              className={classes.strong}
            >
              {schedule.workingDay.amountWork}
            </Typography>
          </Grid>
          <Grid item xs>
            <hr className={classes.vertical} />
          </Grid>
          <Grid item xs={3}>
            <Typography color="textSecondary" align="center">
            {schedule.workingDay.category === 'DAYS' ? 'Dias' : 'Horas'} de folga
            </Typography>
            <Typography
              color="textSecondary"
              variant="body1"
              align="center"
              className={classes.strong}
            >
              {schedule.workingDay.amountLoose}
            </Typography>
          </Grid>
        </Grid>

        <DataTable rows={[schedule == false? undefined : schedule.shifts[0].shiftsTurns]} columns={columns} pagination={false} disableHover="true" />
      </React.Fragment>
    );
  } else {
    content = (
      <DataTable
        rows={schedule == false? undefined : schedule.shifts.map(shift => ({ ...shift.shiftsTurns, days: shift.days.join(' ') }))}
        columns={columns}
        pagination={false}
        disableHover="true"
      />
    );
  }

  return (
    <div style={{ width: '100%' }}>
      <DialogContent>{content}</DialogContent>
    </div>
  );
};

export default withStyles(styles)(ScheduleDialog);
